import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString, IsUUID, IsObject, IsEnum } from 'class-validator'
import { ActivityVisibility } from '../../../enums'

export class UpdateTemplateDto {
  @ApiPropertyOptional({ description: 'Nom du gabarit' })
  @IsOptional()
  @IsString()
  name?: string

  @ApiPropertyOptional({ description: 'Description du gabarit', type: 'string' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({ description: "Type d'activité", format: 'uuid' })
  @IsOptional()
  @IsUUID('4')
  typeId?: string

  @ApiPropertyOptional({ description: 'Contenu initial (seed)', type: Object })
  @IsOptional()
  @IsObject()
  seedContent?: Record<string, any>

  @ApiPropertyOptional({
    description: 'Configuration du gabarit',
    type: Object,
  })
  @IsOptional()
  @IsObject()
  config?: Record<string, any>

  @ApiPropertyOptional({
    description: 'Visibilité du gabarit',
    enum: ActivityVisibility,
  })
  @IsOptional()
  @IsEnum(ActivityVisibility)
  visibility?: ActivityVisibility
}
